<section>
  <header>
    <h2>Proceed to pay</h2>
    <span class="close-btn" role="button" (click)="close()">Close x</span>
  </header>
  <div class="payment-container">
    <div style="display: flex; flex-direction: column; gap: 1rem">
      <p>
        <b>Pay using: </b>
      </p>
      <div class="grid-pile">
        <ng-select
        [clearable]="false"
          [items]="cardList"
          bindValue="paymentMethodId"
          bindLabel="paymentMethodId"
          [(ngModel)]="selectedID"
        >
          <ng-template ng-label-tmp let-card="item">
            <div
              style="padding: 0.3em 0.9em"
              *ngIf="card.paymentMethodId !== ''"
            >
              <span style="display: block"
                >{{ card.brand | titlecase }} ****{{ card.last4 }}</span
              >
              <span>Expires: {{ card.expMonth }}/{{ card.expYear }}</span>
            </div>
            <div
              style="padding: 0.3em 0.9em"
              *ngIf="card.paymentMethodId === ''"
            >
              <span style="display: block">Select here</span>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-card="item">
            <div
              style="padding: 0.3em 0.9em"
              *ngIf="card.paymentMethodId !== ''"
            >
              <span style="display: block"
                >{{ card.brand | titlecase }} ****{{ card.last4 }}</span
              >
              <span>Expires: {{ card.expMonth }}/{{ card.expYear }}</span>
            </div>
            <div
              style="padding: 0.3em 0.9em"
              *ngIf="card.paymentMethodId === ''"
            ></div>
          </ng-template>
        </ng-select>
        <svg
          *ngIf="selectedID == ''"
          width="11px"
          style="
            z-index: 2;
            justify-self: end;
            align-self: center;
            margin-inline-end: 1rem;
          "
          fill="#ffffff"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          stroke="#ffffff"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <path
              d="M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z"
            ></path>
          </g>
        </svg>
        <svg
          *ngIf="selectedID !== ''"
          (click)="selectedID = ''"
          style="
            z-index: 2;
            justify-self: end;
            align-self: center;
            margin-inline-end: 1rem;
          "
          xmlns="http://www.w3.org/2000/svg"
          fill="#ffffff"
          height="16px"
          width="16px"
          viewBox="0 -0.5 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          stroke="#ffffff"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <path
              d="M6.96967 16.4697C6.67678 16.7626 6.67678 17.2374 6.96967 17.5303C7.26256 17.8232 7.73744 17.8232 8.03033 17.5303L6.96967 16.4697ZM13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697L13.0303 12.5303ZM11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303L11.9697 11.4697ZM18.0303 7.53033C18.3232 7.23744 18.3232 6.76256 18.0303 6.46967C17.7374 6.17678 17.2626 6.17678 16.9697 6.46967L18.0303 7.53033ZM13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303L13.0303 11.4697ZM16.9697 17.5303C17.2626 17.8232 17.7374 17.8232 18.0303 17.5303C18.3232 17.2374 18.3232 16.7626 18.0303 16.4697L16.9697 17.5303ZM11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697L11.9697 12.5303ZM8.03033 6.46967C7.73744 6.17678 7.26256 6.17678 6.96967 6.46967C6.67678 6.76256 6.67678 7.23744 6.96967 7.53033L8.03033 6.46967ZM8.03033 17.5303L13.0303 12.5303L11.9697 11.4697L6.96967 16.4697L8.03033 17.5303ZM13.0303 12.5303L18.0303 7.53033L16.9697 6.46967L11.9697 11.4697L13.0303 12.5303ZM11.9697 12.5303L16.9697 17.5303L18.0303 16.4697L13.0303 11.4697L11.9697 12.5303ZM13.0303 11.4697L8.03033 6.46967L6.96967 7.53033L11.9697 12.5303L13.0303 11.4697Z"
              fill="#ffffff"
            ></path>
          </g>
        </svg>
      </div>
    </div>

    <div>
      <p>
        <span
          style="
            color: rgb(66, 191, 237);
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
          "
          >Total Payable</span
        >
      </p>
      <p
        style="
          font-size: 30px;
          font-weight: 600;
          line-height: 30px;
          text-align: left;
        "
      >
        <span>{{ data.totalPayable | currency : "$" }}</span>
      </p>
    </div>
  </div>
  <footer>
    <app-button (click)="pay()" text="Pay" [disabled]="selectedID == ''"></app-button>
    <app-button
      (click)="payWithoutCard()"
      text="Pay with other card"
    ></app-button>
    <app-button
      [isDefault]="false"
      (click)="close()"
      text="Cancel"
    ></app-button>
  </footer>
</section>
